import { render, staticRenderFns } from "./RollBets.vue?vue&type=template&id=3d2aca06&scoped=true"
import script from "./RollBets.vue?vue&type=script&lang=js"
export * from "./RollBets.vue?vue&type=script&lang=js"
import style0 from "./RollBets.vue?vue&type=style&index=0&id=3d2aca06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2aca06",
  null
  
)

export default component.exports